<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import NavBar from '@/components/NavBar.vue'

const authStore = useAuthStore()
</script>

<template>
  <div class="app">
    <NavBar class="navbar-fixed" />
    <main class="main-content">
      <router-view></router-view>
    </main>
  </div>
</template>

<style>
html,
body,
#app,
.app {
  min-height: 100vh;
  min-width: 100vw;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  background: linear-gradient(135deg, #2986d6 0%, #4ecdc4 100%);
}
*,
*::before,
*::after {
  box-sizing: inherit;
}

.navbar-fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 3000;
  width: 100%;
}

/* S'assurer que les blocs principaux gardent un fond blanc pour la lisibilité */
.main-card,
.login-form,
.users-view,
.devices-view,
.settings-view,
.dashboard,
.modal-content {
  background: white;
}

.app {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.main-content {
  flex: 1;

  padding: 1rem;
  flex-grow: 1;
  padding-top: 76px; /* 60px (navbar) + 16px (espace visuel) */
  max-height: calc(100vh - 16px);
  overflow-y: auto;
}
</style>
